module.exports = __webpack_public_path__ + "static/money-age-logo-rsz-9364218872cea58b2728bee622c11aed.png";